import { render, staticRenderFns } from "./UiMaskedTextBox.vue?vue&type=template&id=c86bd0f6&scoped=true"
import script from "./UiMaskedTextBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiMaskedTextBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UiMaskedTextBox.vue?vue&type=style&index=0&id=c86bd0f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86bd0f6",
  null
  
)

export default component.exports